import React from "react"

const Wrapper = ({ children, wrapperType = "default" }) => (
  <div className={`wrapper-${wrapperType}`}>{children}</div>
)

export default Wrapper
